import { render } from "./userBlock.vue?vue&type=template&id=b97407ec&scoped=true"
import script from "./userBlock.vue?vue&type=script&lang=js"
export * from "./userBlock.vue?vue&type=script&lang=js"

import "./userBlock.vue?vue&type=style&index=0&id=b97407ec&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b97407ec"]])

export default __exports__